<template>

  <div @click.stop="onClick" class="product-item" v-if="itemData" title="查看阿里巴巴商品详情">
    <div v-if="isBatchSupport"  class="item-checkbox" title="选择商品">
      <span  :class="{active:itemData.select}">

      </span>
      {{itemData.openOfferId?itemData.openOfferId:(itemData.offerId?itemData.offerId:'')}}

    </div>
    <div  class="product-img"
         :style="{backgroundImage:'url('+ itemData.offerImage.imageUrl+')'}">

    </div>
    <div  class="product-info">
      <div class="subject">{{ itemData.subject }}</div>
      <div class="price-container">
        <div class="price-item">
          <span>单件价格</span>
          <span>￥{{ itemData.offerPrice.consignPrice }}</span>
        </div>
        <div class="price-item">
          <span>批发价</span>
          <span>￥{{ itemData.offerPrice.price }}</span>
        </div>

        <!--        <div class="price-item">-->
        <!--          <span>划线价</span>-->
        <!--          <span style="text-decoration: line-through">{{ itemData.offerPrice.priceUnderLine }}</span>-->
        <!--        </div>-->
      </div>
    </div>
    <alibaba-product-info ref="alibabaProductInfo"></alibaba-product-info>
  </div>
</template>
<script>
import AlibabaProductInfo from "../alibabaProductInfo.vue";

export default {
  emits: ["select"],
  name: 'ProductItem',
  components: {AlibabaProductInfo},
  props: {
    isBatchSupport:false,
    itemData: null,
  },
  methods: {
    onClick(){
      if(this.isBatchSupport){
          this.selItem()
      }else{
        this.showProductInfo()
      }
    },
    selItem() {
      this.$emit("select", !this.itemData.select);
    },
    showProductInfo() {
      if (this.itemData && this.itemData.offerId) {
        this.$refs.alibabaProductInfo.open(this.itemData.offerId);
      }

    }
  }
}
</script>
<style scoped>
.product-item {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 19.5%;
  margin-right: 0.5%;
  border: 1px solid #f1f2f3;

  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 20px;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
  display: flex;
  flex-direction: column;
  position: relative;
}
.product-item:hover{
  box-shadow: 2px 2px 2px rgba(58, 142, 230, 0.3);
}

.product-img {
  cursor: pointer;
  width: 100%;
  padding-bottom: 100%;
  position: relative;
  background-size: cover;
  flex: 0 0 auto;
}

.product-info {
  cursor: pointer;
  font-size: 12px;
  padding: 10px;
  line-height: 16px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-info .subject {
  padding: 5px 0;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-info .price-container {
  display: flex;
  justify-content: space-between;
}

.product-info .price-container .price-item {
  display: flex;
  gap: 5px;
  line-height: 24px;
  color: #ff5000;
}

.item-checkbox {
  cursor: pointer;
  position: absolute;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  padding: 5px;
  border-bottom-right-radius: 5px;
  line-height: 16px;
}

.item-checkbox span {
  display: inline-block;
  padding: 6px;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  border-radius: 4px;

  border: 1px solid #cccccc;
  box-shadow: 0px 0px 2px #cccccc;
}

.item-checkbox span::before {
  position: absolute;
  left: 2px;
  top: 2px;
  content: "";
}

.item-checkbox span.active {
  background-color: #3a8ee6;
  color: #FFFFFF;
}

.item-checkbox span.active::before {
  width: 6px;
  height: 3px;
  display: inline-block;
  border: 2px solid #ffffff;
  border-width: 0 0 1px 1px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  vertical-align: baseline;
}
.product-item:hover .item-checkbox {
  background-color: rgba(79, 157, 250, 0.65);
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/views/alibaba/product/components/alibabaProductItem.vue